import { ButtonIconTransparent } from '@fukku/button/Icon/Transparent/ButtonIconTransparent'
import srOnly from '@fukku/styles/src/srOnly.module.css'
import { cx } from 'classix'
import { IconCloseBig } from 'icons/components/IconCloseBig'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { useDialogContext } from '../../hooks/useDialogContext'

import styles from '../Header.module.css'

type CloseButtonProps = {
	readonly onClose?: () => void
	readonly hasDraggableControl?: boolean
}

export function CloseButton({
	onClose,
	hasDraggableControl,
}: CloseButtonProps) {
	const { t } = useLabels()
	const { api, preventClose } = useDialogContext()

	return (
		(!preventClose || onClose) && (
			<div
				className={cx(hasDraggableControl ? srOnly.className : styles.close)}
			>
				<ButtonIconTransparent
					className={styles.area}
					onClick={onClose ?? api.close}
				>
					<IconCloseBig
						width={20}
						height={20}
						alt={t('accessibility.icon.cross.close.text')}
					/>
				</ButtonIconTransparent>
			</div>
		)
	)
}
